"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TagEditor = void 0;

var _react = _interopRequireDefault(require("react"));

var _atoms = require("../atoms");

var _molecules = require("../molecules");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * TagEditor
 *
 * A component to edit a group of tags
 *
 * @component
 * @category Organisms
 */
var TagEditor = function TagEditor(props) {
  var cats = [];

  var _iterator = _createForOfIteratorHelper(props.tags),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var tag = _step.value;
      var cat = tag.category;

      if (!cats.includes(cat)) {
        cats.push(cat);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var headingType = props.headingType ? props.headingType : _atoms.Label.Type.Heading5;
  return /*#__PURE__*/_react.default.createElement(_atoms.Column, null, cats.map(function (cat) {
    return /*#__PURE__*/_react.default.createElement(_atoms.Column, {
      key: "tag-cat-".concat(cat)
    }, /*#__PURE__*/_react.default.createElement(_atoms.Label, {
      type: headingType,
      content: cat,
      margin: "0 0 4 0",
      color: _atoms.Color.Grey1
    }), /*#__PURE__*/_react.default.createElement(_atoms.Row, {
      marginBottom: "4"
    }, props.tags.filter(function (t) {
      return t.category === cat;
    }).map(function (t) {
      var title = t.editor && t.editor.title ? t.editor.title : t.title;
      return /*#__PURE__*/_react.default.createElement(_molecules.Chip, {
        key: "tag-".concat(cat, "-").concat(t.name),
        background: t.selected ? _atoms.Color.Black : _atoms.Color.Grey4,
        color: t.selected ? _atoms.Color.White2 : _atoms.Color.Black,
        content: title,
        margin: "0 2 2 0",
        onClick: function onClick(e) {
          return props.onTag(t.name);
        },
        fat: true
      });
    })));
  }));
};

exports.TagEditor = TagEditor;
TagEditor.propTypes = {
  /** array of all possible tags */
  tags: _propTypes.default.arrayOf(_propTypes.default.shape({
    name: _propTypes.default.string.isRequired,
    category: _propTypes.default.string.isRequired,
    selected: _propTypes.default.bool.isRequired
  })).isRequired,

  /** event handler when a tag is toggled. Will be passed the tag name */
  onTag: _propTypes.default.func.isRequired,
  headingType: _propTypes.default.oneOf(Object.keys(_atoms.Label.Type).map(function (k) {
    return _atoms.Label.Type[k];
  }))
};